// Original scenarios for applying the company-analysis lessons; all companies and values are hypothetical.
export const analysisReview = {
  moduleId: 'analysis',
  title: '把獲利、資金與估值放在一起看',
  questions: [
    {
      id: 'analysis-margin-and-growth',
      lessonId: 'revenue-margins',
      question: '一家假想公司的去年營收 500 萬元、銷貨成本 325 萬元；今年營收 600 萬元、銷貨成本 420 萬元。兩年口徑一致，哪個判斷正確？',
      options: [
        '營收成長 20%，所以毛利率也成長 20%',
        '毛利金額增加，所以毛利率一定提高',
        '毛利金額從 175 萬增至 180 萬，但毛利率從 35% 降到 30%',
      ],
      answer: 2,
      explanation: '毛利是營收減銷貨成本，兩年分別為 175 萬與 180 萬；再各自除以營收，得到 35% 與 30%。毛利金額增加、毛利率下降可以同時成立。這裡的毛利還沒有扣除其他營業費用及稅負，不能當成淨利。',
    },
    {
      id: 'analysis-roe-capital-structure',
      lessonId: 'roe-leverage',
      question: '甲、乙公司同一年淨利都是 18 萬元，平均股東權益分別為 90 萬與 180 萬元，且甲的負債比率較高。依淨利除以平均權益計算 ROE，最合理的解讀是？',
      options: [
        '甲的 ROE 較高，所以無須再看負債與風險',
        '甲為 20%、乙為 10%，但仍須檢查資本結構與獲利品質',
        '兩家公司淨利相同，因此 ROE 必定相同',
      ],
      answer: 1,
      explanation: '18 ÷ 90＝20%，18 ÷ 180＝10%。ROE 的分母不同就可能改變比率；較高負債與較小權益也可能提高 ROE，但不能據此斷定營運更好或投資較安全。應進一步比較利息負擔、現金流及多期資料。',
    },
    {
      id: 'analysis-free-cash-flow-scope',
      lessonId: 'free-cash-flow',
      question: '假設一年營業活動現金流為 86 萬元，購置生產設備支付 55 萬元。本題明訂簡化 FCF＝營業活動現金流－資本支出，哪個說法正確？',
      options: [
        '簡化 FCF 為 31 萬元，但還要檢查償債及其他必要支出',
        '簡化 FCF 為 141 萬元，設備支出應加回現金',
        '簡化 FCF 為 31 萬元，代表公司一定能全數發給股東',
      ],
      answer: 0,
      explanation: '86 − 55＝31 萬元。這是題目指定的計算口徑；自由現金流沒有所有公司一致採用的定義，且這個簡化數字未必已扣完到期借款本金等必要支出，不能直接當成可分配股利。',
    },
    {
      id: 'analysis-cyclical-peak',
      lessonId: 'cyclical-earnings',
      question: '假想景氣循環公司的股價為 96 元，剛公布的高獲利年度 EPS 為 16 元。另以「全年 EPS 降為 4 元」做壓力情境，假設股價仍是 96 元，應如何解讀？',
      options: [
        '歷史本益比只有 6 倍，已能證明股價便宜',
        '股價沒有改變，兩個情境的本益比都是 6 倍',
        '兩種 EPS 下分別為 6 倍與 24 倍，要檢查高獲利能否延續',
      ],
      answer: 2,
      explanation: '96 ÷ 16＝6 倍，96 ÷ 4＝24 倍。高峰盈餘作為分母時，本益比可能看起來很低；還要觀察完整景氣週期與不同獲利假設。4 元只是壓力情境，不是預測，6 倍或 24 倍也不是自動買賣訊號。',
    },
  ],
};
